import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Stack } from '@mui/material';
import { Button, Typography } from 'cprime-foundational-components';

const sideNavButtonSx = {
  width: '100%',
  minWidth: 0,
  height: '3rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
  textAlign: 'left',
  p: '1rem',
  borderColor: 'divider',
  backgroundColor: 'common.white',
  ':hover, :focus': {
    backgroundColor: 'primary.light',
    color: 'inherit',
    borderColor: 'divider',
  },
};

const AuthenticatorSelector = ({ onSelect }) => (
  <Box
    component="main"
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.default',
      display: 'grid',
      minHeight: '100vh',
      px: 2,
    }}
  >
    <Paper
      aria-labelledby="authenticator-selector-title"
      component="section"
      elevation={0}
      sx={{
        backgroundColor: 'common.white',
        borderRadius: '0.25rem',
        mx: 'auto',
        maxWidth: 304,
        p: 2,
        width: '100%',
      }}
    >
      <Stack spacing={2}>
        <Typography component="h1" id="authenticator-selector-title" variant="h2bold">
          Sign in
        </Typography>
        <Stack spacing={1}>
          <Button onClick={() => onSelect('forgerock')} sx={sideNavButtonSx} variant="tertiary">
            ForgeRock
          </Button>
          <Button onClick={() => onSelect('entra')} sx={sideNavButtonSx} variant="tertiary">
            Microsoft Entra
          </Button>
        </Stack>
      </Stack>
    </Paper>
  </Box>
);

AuthenticatorSelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default AuthenticatorSelector;
